import { queryOptions } from '@tanstack/react-query';

import { personDetailsQueryOptions } from '../../../session';
import { profileOf } from '../domain/profile';

export const accountKeys = {
  all: ['account'] as const,
};

export const accountMutationKeys = {
  changePassword: () => [...accountKeys.all, 'mut', 'change-password'] as const,
  setPassword: () => [...accountKeys.all, 'mut', 'set-password'] as const,
  passwordCode: () => [...accountKeys.all, 'mut', 'password-code'] as const,
  passwordCodeVerify: () => [...accountKeys.all, 'mut', 'password-code-verify'] as const,
  language: () => [...accountKeys.all, 'mut', 'language'] as const,
  phoneCode: () => [...accountKeys.all, 'mut', 'phone-code'] as const,
  phoneVerify: () => [...accountKeys.all, 'mut', 'phone-verify'] as const,
  phoneEditCode: () => [...accountKeys.all, 'mut', 'phone-edit-code'] as const,
  phoneEditVerify: () => [...accountKeys.all, 'mut', 'phone-edit-verify'] as const,
  emailCode: () => [...accountKeys.all, 'mut', 'email-code'] as const,
  emailVerify: () => [...accountKeys.all, 'mut', 'email-verify'] as const,
};

/** The signed-in person's account, from the session's own read of them — never a second read. */
export const profileQueryOptions = () => queryOptions({ ...personDetailsQueryOptions(), select: profileOf });
